/**
 *
 * Asynchronously loads the component for CrosstabsPage
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
